/**
 * Client identity management
 * Generates and persists a unique client ID and optional name
 */

const CLIENT_ID_KEY = "GG:v1:clientId";
const CLIENT_NAME_KEY = "GG:v1:clientName";

/**
 * Generate a unique client ID (UUID v4-like)
 */
function generateClientId(): string {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let id = 'client_';
    for (let i = 0; i < 12; i++) {
        id += chars[Math.floor(Math.random() * chars.length)];
    }
    return id;
}

/**
 * Get the client ID, generating one if it doesn't exist
 */
export function getClientId(): string {
    let id = localStorage.getItem(CLIENT_ID_KEY);
    if (!id) {
        id = generateClientId();
        localStorage.setItem(CLIENT_ID_KEY, id);
    }
    return id;
}

/**
 * Get the client name (user-defined)
 */
export function getClientName(): string {
    return localStorage.getItem(CLIENT_NAME_KEY) ?? "";
}

/**
 * Set the client name
 */
export function setClientName(name: string): void {
    localStorage.setItem(CLIENT_NAME_KEY, name);
    // Dispatch event so UI can update
    document.dispatchEvent(new CustomEvent("client:update"));
}

/**
 * Get full client info
 */
export function getClientInfo(): { id: string; name: string } {
    return {
        id: getClientId(),
        name: getClientName()
    };
}
